import { render, staticRenderFns } from "./RevisionModal.vue?vue&type=template&id=33fe1ebb"
import script from "./RevisionModal.vue?vue&type=script&lang=js"
export * from "./RevisionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports